export default __webpack_public_path__ + "static/media/gepeto_coin.07c572be.png";